import createTheme from '@@/create-theme';

export default createTheme({
    page: () => import('./components/root'),
});
